import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth';
export function PlanFeature({ feature, children }) {
  const { outlet, outlets=[] } = useAuth();
  if(feature==='staff'&&outlets.some(o=>o.entitlements?.staff===true))return children;
  if (outlet?.entitlements?.[feature] !== false) return children;
  return <section className="mx-auto my-8 max-w-xl rounded-xl border border-slate-300 bg-white p-6 text-slate-900" data-testid="plan-upgrade-required">
    <h1 className="text-2xl font-bold">Free and Starter are owner-only</h1>
    <p className="mt-3 text-sm text-slate-600">Manage your restaurant yourself on Free or Starter. Staff accounts, cashier access, kitchen display and KOT printing require Pro.</p>
    <Link to="/admin/subscription" className="mt-5 inline-flex min-h-11 items-center rounded-lg bg-amber-500 px-4 text-sm font-semibold">View plans & upgrade</Link>
  </section>;
}
